import { Component, OnInit, Input, ViewChild, ViewChildren, QueryList } from '@angular/core';
import { VisitorService, VisitorDataResolution } from '../../../services/visitor.service';
import { MatButtonToggleGroup, MatButtonToggle } from '@angular/material';
import { isNullOrUndefined } from 'util';
import { StoreSelection } from '../../../models/store';

const MIN_DATE = new Date(2016, 1, 1);

@Component({
  selector: 'app-datepicker-month',
  templateUrl: './datepicker-month.component.html',
  styleUrls: ['./datepicker-month.component.scss'],
})
export class DatepickerMonthComponent implements OnInit {

  constructor(private _visitorService: VisitorService) {}

  @Input()
  isYearDatepicker;

  @Input()
  selectedStore: StoreSelection;

  @ViewChild(MatButtonToggleGroup) datepickerButtonGroup: MatButtonToggleGroup;
  @ViewChildren(MatButtonToggle) datepickerToggle: QueryList<MatButtonToggle>;

  buttonValues: any[];

  selectedYear: Date = new Date();

  get dateFormat() { return this.isYearDatepicker ? 'yyyy' : 'MMMM'; }

  ngOnInit() {
    this.isYearDatepicker = this.isYearDatepicker.toLowerCase() == 'true' ? true : false;
    if(this.isYearDatepicker) {
      this.setButtonValuesToYears();
    }
    else {
      this.setButtonValuesToMonths();
    }
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.datepickerToggle.forEach(toggle => toggle.buttonToggleGroup = this.datepickerButtonGroup);
      // When a button in the group is clicked, send update to onDateChange with new date
      this.datepickerButtonGroup.valueChange.subscribe((newDate: Date) => this.onDateChange(newDate));
    });
  }

  setButtonValuesToYears() {
    let today: Date = new Date();

    let years: Date[] = [];
    for (let year = MIN_DATE.getFullYear(); year < today.getFullYear(); year++) {
      // Create a new date based on the selected year and month in index
      let date = new Date(year, 1, 1);

      years.push(date);
    }

    this.buttonValues = years;
  }

  setButtonValuesToMonths() {
    let today: Date = new Date();

    let months: Date[] = [];
    for (let month = 0; month < 12; month++) {
      // Create a new date based on the selected year and month in index
      let date = new Date(this.selectedYear.getFullYear(), month, 1);

      // Check if date is valid and add it to the list of months to display
      if(date.getTime() > MIN_DATE.getTime() && date.getTime() <= today.getTime()) {
        months.push(date);
      }
    }

    this.buttonValues = months;
  }

  onDateChange(newDate: Date) {
    if(isNullOrUndefined(newDate)) {
      return;
    }
    // Year
    if(this.isYearDatepicker) {
      this.updateVisitorServiceDatesForYear(newDate);
    }
    // Month
    else {
      this.updateVisitorServiceDatesForMonth(newDate);
    } 
  }

  private getDaysInMonth(date: Date): number {
    // Get the days in the month for date parameter
    // This gets the next month, then goes 1 day backward
    // The day becomes the last day of the current month, which we get with getDate()
    // Explained here: https://stackoverflow.com/questions/1184334/get-number-days-in-a-specified-month-using-javascript
    return new Date(date.getFullYear(), date.getMonth()+1, 0).getDate();
  }

  updateVisitorServiceDatesForYear(date: Date) {
    let firstDayOfYear = new Date(date.getFullYear(), 0, 1);
    let lastDayOfYear = new Date(date.getFullYear()+1, 0, 0);

    // Send new selected date range to the visitor service
    this._visitorService.setDateSelection(firstDayOfYear, lastDayOfYear, VisitorDataResolution.Month, this.selectedStore.storeGuid); 
  }

  updateVisitorServiceDatesForMonth(date: Date) {
    let daysInMonth = this.getDaysInMonth(date);
    // Set fromDate to first day of month
    let _fromDate: Date = new Date(date.getFullYear(), date.getMonth(), 1);
    // Set toDate to last day of month
    let _toDate: Date = new Date(date.getFullYear(), date.getMonth(), daysInMonth);
    
    // Send new selected date range to the visitor service
    this._visitorService.setDateSelection(_fromDate, _toDate, VisitorDataResolution.Day, this.selectedStore.storeGuid); 
  }
}
